import { render } from "./UpdateBanner.vue?vue&type=template&id=c0fb2e7c&scoped=true"
import script from "./UpdateBanner.vue?vue&type=script&lang=js"
export * from "./UpdateBanner.vue?vue&type=script&lang=js"

import "./UpdateBanner.vue?vue&type=style&index=0&id=c0fb2e7c&lang=scss&scoped=true"

import exportComponent from "/home/caleb/Desktop/apps/eventusa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0fb2e7c"]])

export default __exports__